import axiosClient from "@/shared/lib/axios/axios.ts";
import { AxiosResponse } from "axios";
import { ApiResponse } from "@/shared/types/api.ts";
import { Video } from "@/machines/types/video.ts";
import { API_ROUTES } from "@/machines/api/config.ts";
import { getPaginationParams } from "@/shared/utils/pagination/pagination.ts";
import { formatDateTime } from "@/shared/utils/date/format-datetime.ts";

export interface IGetVideoInput {
  device_mxid?: string;
  timestamp?: Date;
  timestamp_before?: number; // seconds before timestamp
  timestamp_after?: number; // seconds after timestamp
  page: number;
  itemsPerPage: number;
}

const getVideoAround = (params: IGetVideoInput, signal?: AbortSignal) => {
  const { offset, limit } = getPaginationParams(params.page, params.itemsPerPage)

  return axiosClient.get<IGetVideoInput, AxiosResponse<ApiResponse<Video[]>>>(API_ROUTES.VIDEO, {
    params: {
      offset,
      limit,
      timestamp: params.timestamp ? formatDateTime(params.timestamp) : undefined,
      timestamp_before: params.timestamp_before,
      timestamp_after: params.timestamp_after,
      device_mxid: params.device_mxid
    },
    signal // Pass the abort signal to axios
  }).then((data) => {
    return data.data;
  })
}

export {
  getVideoAround
}